import React from 'react'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { message } from 'antd'
import FormComponent from './Form'
import { useHistory } from 'react-router-dom'
import { client } from '@utils/client'
import Modal from '@components/Modal'
const Create = (props) => {
  const { setmodalCreateOpen, modalCreateOpen } = props
  const { t } = useLocalization()
  const history = useHistory()
  const handleSubmit = async (data) => {
    setmodalCreateOpen(false)
    try {
      await client.post('/activity', data)

      message.success('สำเร็จ')
      history.push('/activities')
    } catch (e) {
      console.log(e.response.data)
      message.error('ไม่สำเร็จ')
    }
  }

  return (
    <>
      <Modal
        borderRadius
        // style={{ borderRadius: '10px', backgroundColor: 'white' }}
        centered={true}
        width={500}
        title={t('rewards.shop.create.title')}
        open={modalCreateOpen}
        onCancel={() => setmodalCreateOpen(false)}
        maskClosable={false}
        footer={null}
      >
        <FormComponent handleSubmit={handleSubmit} doStatus="create" />
      </Modal>
    </>
  )
}

Create.propTypes = {
  setmodalCreateOpen: PropTypes.func,
  modalCreateOpen: PropTypes.bool,
}

export default Create
